import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
    selector: 'app-panel-header',
    templateUrl: './filter-panel-header.component.html',
})
export class FilterPanelHeaderComponent {
    public readonly count: InputSignal<number> = input.required();
    public readonly title: InputSignal<string> = input.required();
}
